export const QuestionTextKeys = {
	FREELANCE_OPINION: 0,
	STUDIO_OPINION: 1,
	COMMENT_ABOUT_FREELANCER_PUBLIC: 2,
	COMMENT_ABOUT_STUDIO_PUBLIC: 3,
	COMMENT_ABOUT_FREELANCER_PRIVATE: 4,
	COMMENT_ABOUT_STUDIO_PRIVATE: 5,
}

export default { QuestionTextKeys }